import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Download a CSV from a backend GET endpoint (must return text/csv with Content-Disposition).
 */
export async function downloadCsv(path, fallbackName = "download.csv") {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    // Try to read filename from Content-Disposition header
    const disp = res.headers?.["content-disposition"] || "";
    const match = disp.match(/filename="?([^";]+)"?/i);
    const filename = match ? match[1] : fallbackName;
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Download failed");
  }
}
